export default [{
  "name": "北京市",
  "cityCode": 110000,
  "value": ["116.3979471", "39.9081726"]
}, {
  "name": "上海市",
  "cityCode": 310000,
  "value": ["121.4692688", "31.2381763"]
}, {
  "name": "天津市",
  "cityCode": 120000,
  "value": ["117.2523808", "39.1038561"]
}, {
  "name": "重庆市",
  "cityCode": 500000,
  "value": ["106.548425", "29.5549144"]
}, {
  "name": "河北省",
  "cityCode": 130000,
  "value": ["114.4897766", "38.0451279"]
}, {
  "name": "山西省",
  "cityCode": 140000,
  "value": ["112.5223053", "37.8357424"]
}, {
  "name": "辽宁省",
  "cityCode": 210000,
  "value": ["123.4116821", "41.7966156"]
}, {
  "name": "吉林省",
  "cityCode": 220000,
  "value": ["125.3154297", "43.8925629"]
}, {
  "name": "黑龙江省",
  "cityCode": 230000,
  "value": ["126.6433411", "45.7414932"]
}, {
  "name": "浙江省",
  "cityCode": 330000,
  "value": ["120.1592484", "30.265995"]
}, {
  "name": "福建省",
  "cityCode": 350000,
  "value": ["119.2978134", "26.0785904"]
}, {
  "name": "山东省",
  "cityCode": 370000,
  "value": ["117.0056", "36.6670723"]
}, {
  "name": "河南省",
  "cityCode": 410000,
  "value": ["113.6500473", "34.7570343"]
}, {
  "name": "湖北省",
  "cityCode": 420000,
  "value": ["114.2919388", "30.5675144"]
}, {
  "name": "湖南省",
  "cityCode": 430000,
  "value": ["112.9812698", "28.2008247"]
}, {
  "name": "广东省",
  "cityCode": 440000,
  "value": ["113.2614288", "23.1189117"]
}, {
  "name": "海南省",
  "cityCode": 460000,
  "value": ["110.3465118", "20.0317936"]
}, {
  "name": "四川省",
  "cityCode": 510000,
  "value": ["104.0817566", "30.6610565"]
}, {
  "name": "贵州省",
  "cityCode": 520000,
  "value": ["106.7113724", "26.5768738"]
}, {
  "name": "云南省",
  "cityCode": 530000,
  "value": ["102.704567", "25.0438442"]
}, {
  "name": "江西省",
  "cityCode": 360000,
  "value": ["115.8999176", "28.6759911"]
}, {
  "name": "陕西省",
  "cityCode": 610000,
  "value": ["108.949028", "34.2616844"]
}, {
  "name": "青海省",
  "cityCode": 630000,
  "value": ["101.7874527", "36.6094475"]
}, {
  "name": "甘肃省",
  "cityCode": 620000,
  "value": ["103.7500534", "36.0680389"]
}, {
  "name": "广西壮族自治区",
  "cityCode": 450000,
  "value": ["108.3117676", "22.8065434"]
}, {
  "name": "新疆维吾尔自治区",
  "cityCode": 650000,
  "value": ["87.6061172", "43.7909393"]
}, {
  "name": "内蒙古自治区",
  "cityCode": 150000,
  "value": ["111.6632996", "40.8209419"]
}, {
  "name": "西藏自治区",
  "cityCode": 540000,
  "value": ["91.1320496", "29.657589"]
}, {
  "name": "宁夏回族自治区",
  "cityCode": 640000,
  "value": ["106.2719421", "38.4680099"]
}, {
  "name": "台湾省",
  "cityCode": 710000,
  "value": ["120.9581316", "23.8516062"]
}, {
  "name": "香港特别行政区",
  "cityCode": 810000,
  "value": ["114.139452", "22.391577"]
}, {
  "name": "澳门特别行政区",
  "cityCode": 820000,
  "value": ["113.5678411", "22.167654"]
}, {
  "name": "安徽省",
  "cityCode": 340000,
  "value": ["117.2757034", "31.8632545"]
}, {
  "name": "江苏省",
  "cityCode": 320000,
  "value": ["118.7727814", "32.0476151"]
}]